import React, { useState } from "react";
import { Button, MessageBanner } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useMutation } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { approveCoEditionRequestAsCoPublisher, declineCoEditionRequestAsCoPublisher, rejectCoEditionRequest, } from "../../api/coEditionRequestService";
import { CoEditionDecisionModal } from "./CoEditionDecisionModal";
/**
 * Banner on the product detail for a co-edition request filed on behalf of the co-publisher
 * (status AWAITING_CO_PUBLISHER): the co-publisher's users consent or refuse it, the agency may
 * confirm the consent on the co-publisher's behalf or reject the request, everybody else only
 * sees that the request waits for the co-publisher.
 */
export var CoEditionConsentBanner = function (_a) {
    var request = _a.request, ownerName = _a.ownerName, coPublisherName = _a.coPublisherName, isCurrentUserCoPublisher = _a.isCurrentUserCoPublisher, isAgency = _a.isAgency, onChanged = _a.onChanged, onError = _a.onError;
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var _b = useState(null), mode = _b[0], setMode = _b[1];
    var requestId = request.id;
    var approveMutation = useMutation(function () { return approveCoEditionRequestAsCoPublisher(ky, requestId); }, {
        onSuccess: function () {
            return onChanged("ui-br-agency.co-edition.consent.success.approved");
        },
        onError: function () {
            return onError(formatMessage({
                id: "ui-br-agency.co-edition.consent.error.approveFailed",
            }));
        },
    });
    var closeModal = function () { return setMode(null); };
    var finish = function (messageId) {
        closeModal();
        onChanged(messageId);
    };
    var fail = function (message) {
        closeModal();
        onError(message);
    };
    var renderContent = function () {
        if (isAgency) {
            return (React.createElement(React.Fragment, null,
                React.createElement(FormattedMessage, { id: "ui-br-agency.co-edition.consent.agency.banner", values: { coPublisher: coPublisherName !== null && coPublisherName !== void 0 ? coPublisherName : "" } }),
                " ",
                React.createElement(Button, { buttonStyle: "primary", marginBottom0: true, onClick: function () { return setMode("confirmOnBehalf"); } },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.co-edition.consent.agency.confirm" })),
                React.createElement(Button, { marginBottom0: true, onClick: function () { return setMode("reject"); } },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.co-edition.assign.reject" }))));
        }
        if (isCurrentUserCoPublisher) {
            return (React.createElement(React.Fragment, null,
                React.createElement(FormattedMessage, { id: "ui-br-agency.co-edition.consent.coPublisher.banner", values: { owner: ownerName !== null && ownerName !== void 0 ? ownerName : "" } }),
                request.note && (React.createElement("div", null,
                    React.createElement(FormattedMessage, { id: "ui-br-agency.co-edition.consent.coPublisher.note", values: { note: request.note } }))),
                React.createElement(Button, { buttonStyle: "primary", marginBottom0: true, disabled: approveMutation.isLoading, onClick: function () { return approveMutation.mutate(); } },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.co-edition.consent.coPublisher.approve" })),
                React.createElement(Button, { marginBottom0: true, disabled: approveMutation.isLoading, onClick: function () { return setMode("decline"); } },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.co-edition.consent.coPublisher.decline" }))));
        }
        return (React.createElement(FormattedMessage, { id: "ui-br-agency.co-edition.consent.awaiting.info", values: { coPublisher: coPublisherName !== null && coPublisherName !== void 0 ? coPublisherName : "" } }));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(MessageBanner, { type: isAgency || isCurrentUserCoPublisher ? "warning" : "default" }, renderContent()),
        mode === "decline" && (React.createElement(CoEditionDecisionModal, { titleId: "ui-br-agency.co-edition.consent.decline.modal.title", fieldLabelId: "ui-br-agency.co-edition.consent.decline.field.reason", submitLabelId: "ui-br-agency.co-edition.consent.coPublisher.decline", errorMessageId: "ui-br-agency.co-edition.consent.error.declineFailed", onSubmit: function (note) {
                return declineCoEditionRequestAsCoPublisher(ky, requestId, { note: note });
            }, onClose: closeModal, onDone: function () {
                return finish("ui-br-agency.co-edition.consent.success.declined");
            }, onError: fail })),
        mode === "confirmOnBehalf" && (React.createElement(CoEditionDecisionModal, { titleId: "ui-br-agency.co-edition.consent.agency.confirm", fieldLabelId: "ui-br-agency.co-edition.consent.agency.field.note", submitLabelId: "ui-br-agency.co-edition.consent.agency.confirm", errorMessageId: "ui-br-agency.co-edition.consent.error.approveFailed", onSubmit: function (note) {
                return approveCoEditionRequestAsCoPublisher(ky, requestId, { note: note });
            }, onClose: closeModal, onDone: function () {
                return finish("ui-br-agency.co-edition.consent.success.confirmedByAgency");
            }, onError: fail })),
        mode === "reject" && (React.createElement(CoEditionDecisionModal, { titleId: "ui-br-agency.co-edition.assign.modal.titleReject", fieldLabelId: "ui-br-agency.co-edition.assign.field.rejectReason", submitLabelId: "ui-br-agency.co-edition.assign.reject", errorMessageId: "ui-br-agency.co-edition.assign.error.rejectFailed", onSubmit: function (note) {
                return rejectCoEditionRequest(ky, requestId, { reason: note });
            }, onClose: closeModal, onDone: function () {
                return finish("ui-br-agency.co-edition.assign.success.rejected");
            }, onError: fail }))));
};
